import * as Styled from './location-container.skeleton.styles';

export const LocationSkeleton = () => (
  <div data-testid="locations-skeleton">
    {/* @ts-expect-error FIXME: SC6 */}
    <Styled.MapSkeleton amountRows={3} />
  </div>
);
